// A schema is the frontend-exposure boundary for a static bundle: only keys
// listed here ever reach `window.__ENV__` (see generate-env-js.mjs, the
// container-start generator that reads this same schema as its allow-list).
// Each key is the name as it appears in `window.__ENV__` — no `NEXT_PUBLIC_`
// prefix; the prefix was Next's build-time exposure marker, the allow-list
// does that job now.
export function required(key, validate) {
    return { key, required: true, validate };
}
export function optional(key) {
    return { key, required: false };
}
export function defineEnvSchema(keys) {
    return { keys };
}
//# sourceMappingURL=schema.js.map